import { css } from '@emotion/react';
import NvTruncatedTextWithTooltip from 'shared/components/nv-truncated-text-with-tooltip';
import { tripleSpacing } from 'styles/global_defaults/scaffolding';
import { CellProps } from '.';


const TitleCell = ({
  className,
  cell,
}: CellProps) => {
  const styles = css`
    height: ${tripleSpacing}px;
  `;

  const title = cell.getValue();

  return (
    <div css={styles} className={`d-flex align-items-center ${className}`}>
      <NvTruncatedTextWithTooltip
        text={title}
        linesCount={2}
        className='h-100 text-large-body semi-bold align-items-center'
      />
    </div>
  );
};

export default TitleCell;
